import React from "react";

const Top = () => {
  return <img src={require("../BurgerAssets/top.svg")} alt="" />;
};

export default Top;
